import React from 'react';
import { Firm } from 'api';
import Logo from 'components/Logo';
import { IconImage, LogoImage } from './FirmLogo.styles';

type FirmLogoProps = {
  firmInfo: Firm;
  isSidebarOpen: boolean;
};

const FirmLogo = ({ firmInfo, isSidebarOpen }: FirmLogoProps) => {
  if (!firmInfo) {
    return isSidebarOpen ? <Logo variation="onlyWord" /> : <Logo variation="small" />;
  }

  const { icon_url: firmIcon = null, logo_url: firmLogo = null } = firmInfo;

  const FirmLogoComponent = firmLogo ? <LogoImage src={firmLogo} alt="firm logo" /> : <Logo variation="onlyWord" />;

  const FirmIconComponent = firmIcon ? <IconImage src={firmIcon} alt="firm icon" /> : <Logo variation="small" />;

  return isSidebarOpen ? FirmLogoComponent : FirmIconComponent;
};

export default FirmLogo;
